<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>医院列表</a><i class="el-icon-arrow-right"></i><a>医生详情</a><i class="el-icon-arrow-right"></i><a>问诊详情</a></p>
            </div>
        </div>
        <div class="contentRes">
            <div class="contentList" v-if="type == 1">
                <div class="contentStep1Box contentBoxFlex">
                    <img src="../../assets/img/reservation/success.png" style="width:48px;height:48px" alt="" srcset="">
                    <div style="font-size: 24px;color: #00AFB5;margin-top:20px">
                        <div>支付成功，等待医生确认订单</div>
                        <!-- <div>等待医生确认订单</div> -->
                    </div>
                    <div class="DocTopFlexC " style="margin-top:20px">
                        <div class="DocDetailYuBox" @click="goSeeOrder(1)">查看订单</div>
                        <div class="DocDetailCanBox" @click="goSeeindex">返回首页</div>
                    </div>
                    <div  style=" display: flex;flex-direction: column;">
                        <div style="margin-top:45px">
                            <span>预约须知：</span>
                        </div>
                        <div>
                            <span>1.停诊将短信通知，请保持手机畅通实名制预约 </span>
                        </div>
                        <div>
                            <span>2.就诊人信息不符将无法取号</span>
                        </div>
                    </div>
                </div>


                <!-- <div class="contentStep1Box DocTopFlexS" style=" position: relative; ">
                    <div style=" position: relative; ">
                        <img src="../../assets/img/reservation/success.png" style="width:48px;height:48px" alt="" srcset="">
                        <div style="font-size: 24px;color: #00AFB5;margin-top:10px">
                            <div>支付成功，</div>
                            <div>等待医生确认订单</div>
                        </div>
                        <div class="DocTopFlexC " style="margin-top:50px">
                            <div class="DocDetailYuBox" @click="goSeeOrder">查看订单</div>
                            <div class="DocDetailCanBox" @click="goSeeindex">返回首页</div>
                        </div>
                        <div style="margin-top:45px">
                            <span>预约须知：</span>
                        </div>
                        <div>
                            <span>1.停诊将短信通知，请保持手机畅通实名制预约 </span>
                        </div>
                        <div>
                            <span>2.就诊人信息不符将无法取号</span>
                        </div>
                        <div style="width: 1px;height: 110px;background: #E0E0E0;position: absolute; top: 0; right: 0;"></div>
                    </div>
                    <div style="margin-top:15px;font-size: 14px;color: #333333;position: absolute; top: 50px; right: 60px;width:40%" >
                        <div style="display: flex;">
                            在<el-statistic
                            class="el-statistic1"
                                ref="statistic"
                                format="mm 分 ss 秒"
                                :value="deadline3"
                                @finish="hilarity"
                                time-indices
                                style="width: 110px;color:#00AFB5"
                            ></el-statistic>
                            时间内，如果医生未确认订
                        </div>
                        <div>单，本订单将自动作废，支付金额将原路退回！</div>
                    </div>
                </div> -->
            </div>
            <div class="contentList" v-if="type == 2">
                <div class="contentStep1Box contentBoxFlex">
                    <img src="../../assets/img/reservation/fail.png" style="width:48px;height:48px" alt="" srcset="">
                    <div style="font-size: 24px;color: #00AFB5;margin-top:10px">
                        <div>支付失败，请尝试重新支付</div>
                    </div>
                    <div class="DocTopFlexC " style="margin-top:50px">
                        <div class="DocDetailYuBox" @click="goSeeOrder(0)">查看订单</div>
                        <div class="DocDetailCanBox" @click="goSeeindex">返回首页</div>
                    </div>
                </div>
            </div>
            <div class="contentListRight">
                <div style="margin: 19px 31px 28px 23px;">
                    <div class="contentListTopR">
                        <div class="contentListLineR"></div><span>温馨提示</span>
                    </div>
                    <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                        本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                    </div>
                </div>
            </div>
        </div>
        <ft-com></ft-com>
    </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
        return {
            consultationDomain: consultationMainItem,
            consultationDrugDomain:consultationDrugItem,
            patientId:'',
            showStep:4,
            // deadline3: Date.now() + 1000 * 60 * 30,
            type:this.$route.query.type
        }
    },
    mounted(){
        this.http = this.Services.ossUpload;
    },
    methods: {
        hilarity(){
            this.$router.push({
                path: "/reservation/reservationOrderList"
            });
        },
        goSeeOrder(e){
            this.$router.push({
                path: "/reservation/reservationOrderList",
                query:{
                    payType:e
                }
               
            });
        },
        goSeeindex(){
            this.$router.push({
                path: "/index"
            });
        },
    }
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 720px;
    margin-bottom: 20px;
}
.contentList {
    margin-top: 20px;
    width: 800px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.contentStep1Box {
    margin-top: 15px;
    padding: 30px;
    padding-bottom: 60px;
    background-color: #FFFFFF;
    /* min-height:400px; */
}
.drugTitle {
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    padding: 15px 25px;
    font-size: 16px;
    color: #999999;
}
.stepShowclass {
    color: #333333;
    font-weight: bold;
} 
.DocDetailYuBox {
    width: 120px;
    background: #00AFB5;
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
    color: #FFFFFF;
    margin-right: 10px;
    cursor: pointer;
}
.DocDetailCanBox {
    width: 120px;
    border: 1px solid #00AFB5;
    border-radius: 5px;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
    color: #00AFB5;
    margin-right: 10px;
    cursor: pointer;
}
 ::v-deep .el-statistic1 .con  {
    color: #FF0000 !important
}
.contentBoxFlex {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>
